import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../firebase'
import StateContext from '../../StateContext'

function UserFavoritedTeams() {

    const appState = useContext(StateContext)

    const [teams, setTeams] = useState([])

    const [error, setError] = useState("")

    useEffect(() => {

        try {
            const userTeamsRef = firestore.collection("users").doc(appState.userId).collection("favoriteTeams");
            userTeamsRef.orderBy("team_name").onSnapshot(({docs}) => {
                const teams = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setTeams(teams)
            })
        } catch (error) {
            
        }

    }, [appState.userId])

    async function removeHandler(e, favId) {
        e.preventDefault();
        try {
            const favTeamsRef = firestore.collection("users").doc(appState.userId).collection("favoriteTeams").doc(favId);
            favTeamsRef.delete()
        } catch (error) {
            setError(error.message)
        }
    }

    return (
        <div>   
            {teams?.map((team, index) => {
                return (
                    <div key={index} className="card card-body">
                        <div className="row">
                            <div className="col-10">
                                <Link to={`/teams/${team.team_id}`}>
                                    <img src={team.team_logo} alt={team.team_name} className="img-fluid logo-medium" />
                                    <span> {team.team_name}</span>
                                </Link>
                            </div>
                            <div className="col-2">
                                <span className="float-right" style={{cursor: "pointer"}} onClick={(e) => removeHandler(e, team.id)}><i className="fas fa-trash text-danger"></i></span>
                                {error && <p>{error}</p>}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
export default UserFavoritedTeams